import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExploreComponent } from './explore.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ExploreRoutingModule } from './explore-routing.module';
import { FilterComponent } from './filter/filter.component';
import { GlobeComponent } from './globe/globe.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AreaProviderComponent } from './globe/area-provider/area-provider.component';
import { MapsProviderComponent } from './globe/maps-provider/maps-provider.component';
import { PointsProviderComponent } from './globe/points-provider/points-provider.component';
import { ToolbarProviderComponent } from './globe/toolbar-provider/toolbar-provider.component';
import {
    AngularCesiumModule,
    AngularCesiumWidgetsModule,
} from 'angular-cesium';
import { PointInfoProviderComponent } from './globe/info-provider/point-info-provider/point-info-provider.component';
import { PolygonInfoProviderComponent } from './globe/info-provider/polygon-info-provider/polygon-info-provider.component';
import { LoadingComponent } from './loading/loading.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
    declarations: [
        ExploreComponent,
        FilterComponent,
        GlobeComponent,
        AreaProviderComponent,
        MapsProviderComponent,
        PointsProviderComponent,
        ToolbarProviderComponent,
        PointInfoProviderComponent,
        PolygonInfoProviderComponent,
        LoadingComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ExploreRoutingModule,
        AngularCesiumModule.forRoot(),
        AngularCesiumWidgetsModule,
        FlexLayoutModule,
        SharedModule,
    ],
})
export class ExploreModule {}
